import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { XCircle, AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  const failedAttempts = ['Los cursos de "influencer" tradicionales te obligan a grabar vlogs de tu vida privada, algo que no escala ni protege tu privacidad.', 'Intentar usar la IA de forma genérica produce contenido robótico y aburrido que los algoritmos de TikTok e Instagram detectan y entierran.', 'Delegar la edición a agencias externas devora tu presupuesto antes de que veas el primer dólar de ganancia.'];
  return <Section className="bg-brand-darker/50 border-y border-white/5 relative" data-id="element-210">
      <div className="absolute left-0 top-1/2 -translate-y-1/2 w-1/3 h-full bg-red-500/5 blur-[150px] -z-10 pointer-events-none" data-id="element-211" />

      <div className="max-w-4xl mx-auto" data-id="element-212">
        <div className="text-center mb-16" data-id="element-213">
          <div className="inline-flex items-center justify-center p-3 bg-red-500/10 rounded-full mb-6 text-red-400" data-id="element-214">
            <AlertTriangle size={32} data-id="element-215" />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold mb-8" data-id="element-216">
            El Problema Real
          </h2>
          <p className="text-xl text-brand-gray leading-relaxed" data-id="element-217">
            Crear contenido tradicional es agotador. Requiere iluminación
            perfecta, horas de grabación, edición manual tediosa y, sobre todo,
            la presión psicológica de poner tu cara frente al mundo.
            <br data-id="element-218" />
            <br data-id="element-219" />
            La mayoría de los emprendedores hispanos en EE.UU. abandonan sus
            proyectos digitales antes de los 30 días porque la fricción de la
            exposición es demasiado alta o porque simplemente no tienen 10 horas
            al día para editar un video de 60 segundos.
          </p>
        </div>

        <div className="mt-20" data-id="element-220">
          <h3 className="text-2xl md:text-3xl font-bold text-center mb-10 text-white/80" data-id="element-221">
            Lo Que Ya Intentaste{' '}
            <span className="text-red-400" data-id="element-222">No Funcionó</span>
          </h3>

          <div className="space-y-6" data-id="element-223">
            {failedAttempts.map((item, index) => <motion.div key={index} className="glass-card p-6 md:p-8 rounded-xl flex gap-6 items-start border-red-500/20 hover:border-red-500/40 transition-colors" initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.2
          }} data-id="element-224">
                <XCircle className="text-red-500 flex-shrink-0 mt-1" size={28} data-id="element-225" />
                <p className="text-lg text-white/80 leading-relaxed" data-id="element-226">{item}</p>
              </motion.div>)}
          </div>
        </div>
      </div>
    </Section>;
}